const _gg = typeof _gg == "object" ? _gg : {};
const html = document.documentElement;

const win = window;
window.requestAnimationFrame =
    win.requestAnimationFrame ||
    win.mozRequestAnimationFrame ||
    win.webkitRequestAnimationFrame ||
    win.msRequestAnimationFrame ||
    win.oRequestAnimationFrame ||
    // IE Fallback
    function(callback) {
        win.setTimeout(callback, 1000 / 60);
    };

function domReady(callback) {
    let firstRun = true;

    function runCallback(event) {
        if (firstRun) {
            if (typeof callback == "function") {
                callback(event);
            }
            firstRun = false;
        }
    }

    if (document.readyState == "loading") {
        document.addEventListener("readystatechange", runCallback);
    } else {
        runCallback();
    }
}

_gg.html = html;
_gg.isLive = html.classList.contains("-live");
_gg.language = html.lang || "de";
_gg.domReady = domReady;

window._gg = _gg;

export { domReady };
